// Real assets — official Soul Trip portraits, YouTube trailers, channel link
export const VIJAY_DATLA_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_virtual-journey-hub-1/artifacts/a1pb3oee_IMG_1937.jpeg";

export const SOUL_TRIP_POSTER =
  "https://customer-assets.emergentagent.com/job_virtual-journey-hub-1/artifacts/mh389553_IMG_1894.jpeg";

export const YOUTUBE_CHANNEL = "https://youtube.com/@soultrip-talks";

// Promotional theme song
export const THEME_SONG_YT_ID = "sMZZaf_bmiY";

// Season 1 master trailer (covers all 6 episodes, useful as hero + fallback)
export const SEASON_TRAILER_YT_ID = "wlPS1537A6I";

const yt = (id) => ({
  ytId: id,
  poster: `https://img.youtube.com/vi/${id}/maxresdefault.jpg`,
  // Used by the hover preview / modal embed (muted autoplay loop)
  video: `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&modestbranding=1&rel=0&playsinline=1`,
  // Opened in a new tab when user clicks "Watch on YouTube"
  youtube: `https://www.youtube.com/watch?v=${id}`,
});

export const EPISODES = [
  {
    id: "ep-01", number: 1,
    title: "Whispers of the Eastern Ghats",
    location: "Maredumilli",
    region: "Andhra Pradesh · Eastern Ghats",
    lat: 17.79, lng: 81.65,
    guest: "Jagapathi Babu",
    duration: "Trailer · 01:47",
    streamingDate: "Apr 23",
    description:
      "Deep into the bamboo forests of Maredumilli with Jagapathi Babu — an ancient conversation about silence, ancestors and the land that remembers everything.",
    ...yt("t0ozxUI_vXY"),
  },
  {
    id: "ep-02", number: 2,
    title: "Salt, Sun and Solitude",
    location: "Havelock Island",
    region: "Andaman & Nicobar Islands",
    lat: 11.99, lng: 93.00,
    guest: "Varsha Bollamma",
    duration: "Trailer · 02:00",
    streamingDate: "Apr 30",
    description:
      "Bioluminescent shores, free-divers, and a sunrise conversation with Varsha Bollamma about the kind of stillness only an island can give you.",
    ...yt("jb8mSGj7JUY"),
  },
  {
    id: "ep-03", number: 3,
    title: "Tides of South Goa",
    location: "Palolem · South Goa",
    region: "Konkan Coast",
    lat: 15.01, lng: 74.02,
    guest: "Srikanth",
    duration: "Trailer · 01:20",
    streamingDate: "May 07",
    description:
      "Beyond the postcards — Portuguese ruins, fish curry kitchens, and an honest talk with Srikanth about leaving the city behind.",
    ...yt("iYqWodIhbQQ"),
  },
  {
    id: "ep-04", number: 4,
    title: "Above the Clouds, Manali",
    location: "Solang · Manali",
    region: "Himalayas · Himachal Pradesh",
    lat: 32.24, lng: 77.19,
    guest: "Akash Puri",
    duration: "Trailer · 01:30",
    streamingDate: "May 14",
    description:
      "Trekking past frozen waterfalls into a monastery at 9,000 feet with Akash Puri — a conversation about devotion, distance and the air up here.",
    ...yt("RPRmzgXEO8o"),
  },
  {
    id: "ep-05", number: 5,
    title: "The Forgotten Coast of Honnavar",
    location: "Honnavar",
    region: "Karnataka · Western Ghats",
    lat: 14.28, lng: 74.44,
    guest: "Actor Ali",
    duration: "Trailer · 01:29",
    streamingDate: "May 21",
    description:
      "Where the Sharavathi meets the sea — fishermen's songs, a 600-year-old temple, and an unforgettable conversation with Actor Ali on home as a verb.",
    ...yt("gecQ8tqFDm8"),
  },
  {
    id: "ep-06", number: 6,
    title: "Tigers, Tribes & Nallamala",
    location: "Nallamala Forest",
    region: "Andhra Pradesh · Eastern Ghats",
    lat: 16.00, lng: 78.85,
    guest: "Shivani & Shivatmika Rajasekhar",
    duration: "Sneak peek · 05:06",
    streamingDate: "Coming Soon",
    isUpcoming: true,
    description:
      "With the Chenchu tribe under a cathedral of saagar trees — sisters Shivani & Shivatmika Rajasekhar on belonging, the wild, and what we owe the forest. (Full trailer dropping soon — catch the sneak peek in the Season 1 trailer.)",
    // Fallback to the master season trailer until the dedicated trailer is released
    ...yt("wlPS1537A6I"),
  },
];

export const SEASON_2_PINS = [
  { id: "s2-01", label: "Kathmandu · Monasteries",   region: "Nepal · Himalaya",          lat: 27.7172, lng: 85.3240 },
  { id: "s2-02", label: "Sri Lanka · Hill Country",   region: "Kandy · Indian Ocean",      lat: 7.2906,  lng: 80.6337 },
  { id: "s2-03", label: "Pondicherry · French Riviera", region: "Tamil Nadu · Coromandel",  lat: 11.9416, lng: 79.8083 },
  { id: "s2-04", label: "Lakshadweep · Atolls",       region: "Arabian Sea · India",       lat: 10.5667, lng: 72.6417 },
  { id: "s2-05", label: "Kashmir · Dal Lake",          region: "Srinagar · Jammu & Kashmir", lat: 34.0837, lng: 74.7973 },
  { id: "s2-06", label: "Cambodia · Angkor",           region: "Siem Reap · Khmer Empire",  lat: 13.4125, lng: 103.8667 },
];
